module.exports = __webpack_public_path__ + "static/terrain_map-acf12ab654276d094b57d481f9c4e4ea.png";